module.exports = __webpack_public_path__ + "img/main4.f4caeeb2.png";